import { makeStyles } from '@mui/styles';

const useCustomDialogStyles = makeStyles({
	root: {
		alignItems: 'center',
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		left: 0,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: 2000,
	},
	bg: {
		backgroundColor: 'rgba(255, 255, 255, 0.5)',
		height: '100%',
		left: 0,
		position: 'absolute',
		top: 0,
		width: '100%',
		zIndex: 1,
	},
	dialogContainer: {
		backgroundColor: 'white',
		boxShadow: '0px 0px 7px #00000029',
		minWidth: 402,
		paddingBottom: 24,
		paddingLeft: 32,
		paddingRight: 24,
		paddingTop: 32,
		zIndex: 2,
	},
	actions: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: 26,
		gap: '0 8px',
	},
});

export default useCustomDialogStyles;
